import React, { useContext } from 'react';

import TrackingContext from '../contexts/TrackingContext';

type EventTrackingAppProps = {
  name: string;
};

const EventTrackingApp: React.FC<EventTrackingAppProps> = ({
  name,
  children,
}) => {
  const trackingContext = useContext(TrackingContext);

  return (
    <TrackingContext.Provider
      value={{ ...trackingContext, applicationName: name }}
    >
      {children}
    </TrackingContext.Provider>
  );
};

export default EventTrackingApp;
